<!-- For the time being this Just accepts the users passed in, no need to have any AJAX -->
<template>
    <div class="">

        <div :class="['form-group', { 'mb-4': !removeMargin }]">

            <label for="user_id">
                <strong>
                    User
                    <span v-if="this.required" class="text-danger">*</span>
                </strong>
            </label>

            <v-select
                v-model="selectedUser"
                :options="users"
                :clearable="true"
                placeholder="Select a User"
                label="username"
            />

            <input type="hidden" name="user_id" :value="selectedUser ? selectedUser.id : ''">

            <div v-if="errors.length > 0" >
                <div class="alert alert-danger mt-2" role="alert" v-for="(error, index) in errors" :key="index">
                    {{ error }}
                </div>
            </div>

        </div>

    </div>

</template>

<script>

import VSelect from 'vue-select';

export default {

    props: {
        user: {
            type: Object,
            default: {},
            required: false
        },
        passedUsers: {
            type: Array,
            default: () => [],
            required: true
        },
        old: {
            type: String,
            required: false
        },
        errors: {
            type: Array,
            required: false
        },
        disableWhenPassedUser: {
            type: Boolean,
            default: false,
            required: false
        },
        required: {
            type: Boolean,
            default: false,
            required: false
        },
        removeMargin: {
            type: Boolean,
            default: false,
            required: false
        }
    },

    components: {
        VSelect
    },

    data() {
        return {
            selectedUser: null,
            users: [],
        }
    },

    mounted() {

        this.users = this.passedUsers.length > 0 ? this.passedUsers : [];

        if (this.user) {
            this.selectedUser = this.users.find(u => u.id === this.user.id) || null;
        }

        if (this.old) {
            this.selectedUser = this.users.find(user => user.id === this.old);
        }

    },

}

</script>
